<template>
  <div class="config-form-content">
    <div class="titleContainer">
      <h3>Informações de Básicas</h3>
      <small>Crie as informações básicas do seu curso, após salvar, você poderá personalizar ecriar os módulos e atividades.</small>
    </div>
    <div class="content-wrapper primary">
      <div class="wrapper-inner">
        <div class="content-text">
        </div>
        <div class="content-form">
          <div class="row">          
            <div id="collapseOne" class="accordion-collapse collapse show flex" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="row">
                <div class="col-form-inner col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <div class="form-label">
                      <label> Nome do Curso 
                        <v-tooltip text="Campo obrigatório" location="top">
                          <template v-slot:activator="{ props }">
                            <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                          </template>
                        </v-tooltip>
                      </label>
                    </div>
                    <div class="form-input">
                      <input
                        type="text" 
                        required
                        class="form-control"
                        v-model="name"
                        placeholder="Nome do Curso"
                        @keyup="formatString"
                      />
                      <small class="alertText" v-show="showAlerts[0]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                      <small>Nome administrativo do seu curso, uso interno.</small>
                    </div>
                  </div>
                </div>

                <div class="col-form-inner col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <div class="form-label">
                      <label> Nome Comercial <v-tooltip text="Campo obrigatório" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip></label>
                    </div>
                    <div class="form-input">
                      <input
                        type="text" 
                        required
                        class="form-control"
                        v-model="comercialName"
                        placeholder="Nome Comercial"
                      />
                      <small class="alertText" v-show="showAlerts[1]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                      <small>Nome comercial do seu curso, uso externo.</small>
                    </div>
                  </div>
                </div>

                <div class="col-form-inner col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <div class="form-label">
                      <label> Link <v-tooltip text="Campo obrigatório" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip></label>
                    </div>
                    <div class="form-input">
                      <input
                        type="text" 
                        required
                        class="form-control"
                        placeholder="/nomedocurso"
                        v-model="url"
                      />
                      <small class="alertText" v-show="showAlerts[2]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                      <small>Link do curso, seguido do /domínio.</small>
                    </div>
                  </div>
                </div>

                <div class="col-form-inner col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <label class="label-form"> Status  <v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                    <select class="select-mode" v-model="status">
                      <option value="3">Ativo e Disponível na Loja</option>
                      <option value="2">Ativo e Indisponível na Loja</option>
                      <option value="1">Pendente</option>
                      <option value="0" selected>Inativo</option>
                    </select>
                    <small class="alertText" v-show="showAlerts[3]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                    <small>Status e visibilidade do curso para acesso.</small>
                  </div>
                </div>

                <div class="col-form-inner col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <label class="label-form"> Prazo de Disponbilidade <v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                    <select class="select-mode" v-model="avaliable">
                      <option value="0" selected>Não Possui</option>
                      <option :value="index" v-for="item, index in 365" :key="index">
                        {{item}} dia(s)
                      </option>
                    </select>
                    <small class="alertText" v-show="showAlerts[4]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                    <small>Prazo de acesso para o curso.</small>
                  </div>
                </div>

                <div class="col-form-inner col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <div class="form-label">
                      <label> Preço <v-tooltip text="Campo obrigatório" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip></label>
                    </div>
                    <div class="form-input">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="R$ 99,99"
                        v-model="price"
                      />
                      <small class="alertText" v-show="showAlerts[5]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                      <small>Preço total do curso.</small>
                    </div>
                  </div>
                </div>

                <div class="col-form-inner col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <div class="form-label">
                      <label> Desconto a Vista <v-tooltip text="Campo obrigatório" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip></label>
                    </div>
                    <div class="form-input">
                      <input
                        type="text" 
                        required
                        class="form-control"
                        placeholder="R$ 19,99"
                        v-model="discount"
                      />
                      <small class="alertText" v-show="showAlerts[6]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                      <small>Desconto em real do curso.</small>
                    </div>
                  </div>
                </div>

                <div class="col-form-inner col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <label class="label-form"> Certificado  <v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                    <select class="select-mode" v-model="certificated">
                      <option value="1" selected>Ativo</option>
                      <option value="0">Desabilitado</option>
                    </select>
                    <small class="alertText" v-show="showAlerts[7]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                    <small>Possui certificado?</small>
                  </div>
                </div>

                <div class="col-form-inner col-12 col-md-6 col-lg-6" v-if="certificated==1">
                  <div class="form-group">
                    <label class="label-form"> Nota de Aprovação <v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                    <select class="select-mode" v-model="notaAprovacao">
                      <option value="0" selected>Não Possui</option>
                      <option :value="index+1" v-for="item,index in 10" :key="index">
                        {{item}}
                      </option>
                    </select>
                    <small class="alertText" v-show="showAlerts[8]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                    <small>Nota de aprovação mínima para conclusão.</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions">
            <button class="btn" @click="(()=>this.$router.push('/admin/colecao/'+this.currentCollections.id))">Cancelar</button>
            <button class="btn" @click="createCourse()">Salvar</button>
      </div>
    </div>
  </div>

  <v-dialog
    v-model="dialog"
    width="auto"
  >
    <v-card
      max-width="400"
      prepend-icon="mdi-update"
      text="Um ou mais campo não foram preenchidos corretamenta, por favore revise-os."
      title="Ops, há algum erro!"
    >
      <template v-slot:actions>
        <v-btn
          class="ms-auto"
          text="Ok"
          @click="dialog = false"
        ></v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/utils/courses';
import apiAWS from '@/utils/storage/aws';

import { mapState, mapActions } from 'vuex';

export default{
    data(){
        return{
          dialog:false,
          hasError:false,
          hasSaved:false,
          name:"",
          comercialName:"",
          url:"",
          status:3,
          price:null,
          discount: null,
          shortDescription:null,
          longDescription:null,
          certificated:0,
          imageBanner:null,
          imageThumbnail:null,
          imagePreviewThumbnail:null,
          imagePreviewBanner:null,
          notaAprovacao:0,
          avaliable:0,
          activeTab:[true, false],
          showAlerts:[],
          noErros:false,
          windowWidth: window.innerWidth,
        }
    },
    computed:{
      ...mapState(['token']),
    },
    methods:{
      ...mapActions(['storeIdCourse']),

     
      formatString() {
        this.comercialName = this.name;

        let formatted = this.name.trim().toLowerCase();

        formatted = formatted.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

        formatted = formatted.replace(/\s+/g, '-'); 
        formatted = formatted.replace(/[^\w\s-]/g, ''); 

        this.url = '/' + formatted;
      },

      updateContentShortDescription(value){
      this.shortDescription=value;
      },
      updateContentLongDescription(value){
      this.longDescription=value;
      },

      async validateFields() {
        if (!this.name || !this.comercialName || !this.url || !this.price  || !this.shortDescription || !this.longDescription) {
          
            this.dialog = true;
            return false; 
        }
        return true; 
    },

      async createCourse() {
       
          let price = this.price;
          let discount = this.discount;

          const obj = {
            "name": this.name,
            "comercialName": this.comercialName,
            "url": this.url, 
            "status": this.status,
            "dayExpired": this.avaliable,
            "price": price ? price.toString().replace(',','.'): null,
            "discount": discount ? discount.toString().replace(',','.'): 0,
            "certificate": this.certificated,
            "approved": this.notaAprovacao ? this.notaAprovacao : 0,
            "shortDescription": this.shortDescription,
            "longDescription": this.longDescription, 
            "imagePath": this.imageBanner,
            "imagePath2": this.imageThumbnail,
          
          }

          Object.entries(obj).forEach(([key, value], index) => {
            this.noErros = false;
          if (value==null || value=='') {
            if (key !== 'certificate' && key !== 'approved' && key !== 'dayExpired') {
                    this.showAlerts[index] = true;
                    this.noErros = true;
                }
              }
          });   
          
          try {
              const response = await api.createNewCourse(obj, this.token);

              this.storeIdCourse({IdCourse:response.id});
              // window.location.href = '/dashboard/curso/';
              
          } catch (error) {
              console.error('Error fetching API Create Course:', error);
          }
      },
      async putFileAws(url, file){
        try {
            const response = await apiAWS.putFileAWS(url, file);
        } catch (error) {
            console.error('Erro ao enviar arquivo para AWS');
        }
      },
      async updateFilePathBanner(event){
          const file = event.target.files[0];
          this.imagePreviewBanner = URL.createObjectURL(file);
          try {
              const response =  await apiAWS.getSignatureImage(this.token, file.name);
              this.putFileAws(response.url, file);
              this.imageBanner = response.token;
              console.debug(response);
          } catch (error) {
              console.error('Erro na geração do TOKEN AWS')
          }
      },
      async updateFilePathThumbnail(event){
          const file = event.target.files[0];
          this.imagePreviewThumbnail = URL.createObjectURL(file);
          try {
              const response =  await apiAWS.getSignatureImage(this.token, file.name);
              this.putFileAws(response.url, file);
              this.imageThumbnail = response.token;
          } catch (error) {
              console.error('Erro na geração do TOKEN AWS')
          }
      },
    },
    props:{
        saved: Boolean
    }
}
</script>

<style scoped>
.config-form.primary {
  background-color: rgb(255, 255, 255);
  border-radius: 0px 0px 0.5em 0.5em;
  padding: 010px;
  overflow: hidden;
}
.titleContainer {
  display: block;
  text-align: left;
  padding: 0;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.col-form-inner.col-12.col-md-6.col-lg-6 {
  padding: 0;
}
</style>
<style>
@import "./tabs.css";
.ql-editor.ql-blank::before {
  color: white;
}
@media (max-width: 500px) {
  .form-caption {
    display: none;
  }
  .upload-image {
    position: relative;
    width: 100% !important;
  }
  .btn-add-module {
    padding-left: 0.4rem !important;
    padding-right: 0.4rem !important;
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 28px;
    color: #fff;
    background-color: #280494 !important;
    border: none;
    border-radius: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  tr.title-table {
    background-color: #280494 !important;
    color: white;
  }
}
</style>